import { ClonePrompt } from '@wix/ambassador-devcenter-apps-v1-app-template/types';

export const getDisplayPackageManager = (clonePrompt: ClonePrompt) =>
  clonePrompt.packageManager?.toLowerCase();
